import { css } from 'styled-components';
import {
  grid, gridUnit, ThemedFunctor, getSpacing, SpacingName,
} from '@doveit/lego';

export const list: ThemedFunctor = ({
  theme,
}) => css`
  ${grid(theme)}
  ${getSpacing.margin(theme, [SpacingName.NEGATIVE_SMALLER, SpacingName.NEGATIVE_SMALL])}
`;

export const item: ThemedFunctor = ({
  theme,
}) => css`
  ${gridUnit(theme, { size: { MD: 1 / 2, LG: 1 / 3 } })}
  ${getSpacing.padding(theme, [SpacingName.SMALLER, SpacingName.SMALL])}
`;
